import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Verifying payment...");
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const orderId = query.get("order_id");

    if (!orderId) {
      setStatus("❌ No order found.");
      return;
    }

    const verifyPayment = async () => {
      try {
        const res = await axios.get(`${API_URL}/orders/${orderId}`);
        setOrderData(res.data);

        setStatus(
          res.data.order_status === "PAID"
            ? "✅ Payment Successful!"
            : "❌ Payment Failed or Pending."
        );
      } catch (err) {
        console.error("Payment verification error:", err.response?.data || err.message);
        setStatus("⚠️ Error verifying payment.");
      }
    };

    verifyPayment();
  }, [location]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>{status}</h2>

      {orderData && (
        <div style={{ marginTop: "20px", fontSize: "16px" }}>
          <p><b>Order ID:</b> {orderData.order_id}</p>
          <p><b>Amount:</b> ₹{orderData.order_amount}</p>
          <p><b>Status:</b> {orderData.order_status}</p>
        </div>
      )}

      <button
        onClick={() => navigate("/")}
        style={{
          marginTop: "30px",
          padding: "12px 24px",
          borderRadius: "8px",
          border: "none",
          backgroundColor: "#ff6600",
          color: "#fff",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        Go to Home
      </button>
    </div>
  );
};

export default PaymentSuccess;
